/**
 * Load Posts
 *
 * todo: Update to work with taxonomy filter
 */

import PostComponent from "../components/PostComponent";

class LoadPosts {

    constructor(element) {
        if (!(element instanceof HTMLElement)) {
            throw new TypeError('Invalid element');
        }

        this.container = element;

        this.loadButton = this.container.querySelector('[data-action="load-posts"]');

        if (!this.loadButton) throw new Error('No load button present to load more posts');

        // Load Button should be the last col in the grid, append posts before this column element
        this.insertBefore = this.loadButton.parentElement;

        this.postType = this.container.dataset.postType ? this.container.dataset.postType : 'post';
        this.paged = 2;
        this.postsPerPage = this.container.dataset.postsPerPage ? this.container.dataset.postsPerPage : 9;
        this.taxonomies = {
            'services': this.container.dataset.taxonomyServices,
            'sectors': this.container.dataset.taxonomySectors
        };

        this.loadButton.addEventListener('click', this.loadPosts.bind(this));
    }

    loadPosts(event) {
        if (this.loadButton.classList.contains('progress')) {
            // Prevent addition call to fetch posts is already in progress
            return;
        }

        // Indicate that something is happening, and prevent additional call while in progress
        this.loadButton.classList.toggle('progress', true);

        let url = new URL(`${window.rest_api.url}?action=get_posts&post_type=${this.postType}&paged=${this.paged++}&posts_per_page=${this.postsPerPage}`);

        Object.entries(this.taxonomies).forEach(entry => {
            // Add taxonomies to search params
            const [key, value] = entry;
            if (value) {
                url.searchParams.set(key, value);
            }
        });

        const request = fetch(url)
            .then(response => response.json())
            .then(data => {

                if (data.count > 0) {
                    // Generate markup for each post, and append to the grid
                    data.data.map(props => PostComponent(props))
                        .forEach(markup => this.insertBefore.insertAdjacentHTML('beforebegin', markup));
                }

                // Once posts would be loaded clear progress
                this.loadButton.classList.toggle('progress', false);

                return data.count;
            })
            .then(count => {
                if (count < 9) {
                    // If less than 9 posts are returned,
                    //  then there will be no more posts to return on additional calls
                    //  so disable the load button
                    this.loadButton.disabled = true;
                }
            });
    }
}

export default LoadPosts;
